import React from 'react';
import { Card, Avatar, Tag } from 'antd';
import {
    HistoryOutlined,
    WalletOutlined,
    DollarOutlined,
    CalendarOutlined,
    FileTextOutlined
} from '@ant-design/icons';
import { cn } from '../../../../utils/cn';

const EnhancePaymentHistoryCardView = ({
    record,
    onCardClick,
}) => {
    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="space-y-4 text-left">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 overflow-hidden">
                        <Avatar
                            size={48}
                            className="flex-shrink-0 font-semibold text-lg !bg-primary"
                            icon={<HistoryOutlined />}
                        />
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate" title={record.amount}>
                                {record.amount}
                            </h3>
                            <p className="text-gray-500 text-sm mb-0 truncate" title={record.paymentGateway}>
                                Gateway: {record.paymentGateway}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Amount and Gateway Info */}
                <div className="space-y-2 border-b border-gray-200 pb-3">
                    <div className="flex items-center text-sm text-gray-600">
                        <DollarOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.amount}>{record.amount}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                        <WalletOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate font-medium" title={record.paymentGateway}>{record.paymentGateway}</span>
                    </div>
                </div>

                {/* Details Section Section */}
                <div className="space-y-3">
                    {/* Description */}
                    <div className="flex items-start justify-between">
                        <span className="text-sm text-gray-600 font-medium whitespace-nowrap mr-2">
                            <FileTextOutlined className="mr-1" />
                            Description:
                        </span>
                        <span className="text-sm text-gray-700 truncate text-right italic" title={record.description}>
                            {record.description ?? "-"}
                        </span>
                    </div>

                    {/* Status Placeholder (Matching Tag Style) */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            Status:
                        </span>
                        <Tag color="success" className="m-0">
                            Completed
                        </Tag>
                    </div>

                    {/* Payment At */}
                    <div className="flex items-center justify-between border-t border-gray-200 pt-3 mt-1">
                        <span className="text-sm text-gray-600 font-medium">
                            <CalendarOutlined className="mr-1" />
                            Payment At:
                        </span>
                        <div className="text-right">
                            <div className="text-xs font-semibold text-gray-700">{record.paymentAt}</div>
                            <div className="text-[10px] text-gray-400">{record.paymentAtFromNow}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancePaymentHistoryCardView;
